import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import Form, { preloadForm } from '../components/form';

interface FormProcessorElement extends Element {
  props: Element['props'] & {
    name: string;
    'data-erom-form-name': string;
    'data-erom-form-error-text': string;
    'data-erom-form-success-text': string;
    errorText?: string;
    successText?: string;
  };
}

const form: Processor<FormProcessorElement> = {
  priority: 10,
  name: 'form',
  test: ({ node }) => !!node.props?.className && node.props.className.includes('wp-block-erom-form'),
  processor: ({ node }) => {
    const formName = node.props['data-erom-form-name'];
    const errorText = node.props['data-erom-form-error-text'];
    const successText = node.props['data-erom-form-success-text'];

    // Preload form data into SWR cache
    if (formName) {
      preloadForm(formName);
    }

    node.props.name = formName;
    node.props.errorText = errorText;
    node.props.successText = successText;
    node.component = Form as ComponentType;

    return node;
  }
};

export default form;
